import { Http } from '../../../support';

const initialState = {
  busy: false,
  verify: false,
};

const setPartialState = (store, data) => {
  store.setState((state) => {
    state.cuenta.configuracion.verification = {
      ...state.cuenta.configuracion.verification,
      ...data,
    };
  });
};

const verify = async (store, data = {}) => {
  store.setState((state) => {
    state.cuenta.configuracion.verification.busy = true;
  });

  try {
    const headers = {
      'X-Tenancy': 'fa/live',
    };

    const response = await Http.post(`/auth/me/verify`, data, { headers });

    store.setState((state) => {
      state.cuenta.configuracion.verification.busy = true;
      state.cuenta.configuracion.verification.data = response;
    });
  } catch (error) {
    store.setState((state) => {
      state.cuenta.configuracion.verification.busy = true;
      state.cuenta.configuracion.verification.error = error.data || error;
    });
  }
};

const reset = (store) => {
  store.setState((state) => {
    state.cuenta.configuracion.verification = { ...initialState };
  });
};

const EmailVerificationStore = {
  state: () => initialState,
  actions: {
    setPartialState,
    verify,
    reset,
  },
};

export default EmailVerificationStore;
